import './notification-activation-status/notification-activation-status.component';
import './notification-activation-status/notification-activation-status.scss';

import './notification-type-status/notification-type-status.component';
import './notification-type-status/notification-type-status.scss';

import './notifications-configuration/notifications-configuration.component';
import './notifications-configuration/notifications-configuration.scss';

import './notifications-table/notifications-table.component';
import './notifications-table/notifications-table.scss';

import './notifications-table-row/notifications-table-row.component';
import './notifications-table-row/notifications-table-row.scss';

import './notifications-view/notifications-view.component';
import './notifications-view/notifications-view.scss';

import './notification-configuration-form/notification-configuration-form.component';
import './notification-configuration-form/notification-configuration-form.scss';

import './whatsapp-notification-configuration-form/whatsapp-notification-configuration-form.component';
import './whatsapp-notification-configuration-form/whatsapp-notification-configuration-form.scss';
